export enum PaymentInstrumentType {
  ADYEN_KLARNA = 'ADYEN_KLARNA',
  ADYEN_BANCONTACT_CARD = 'ADYEN_BANCONTACT_CARD',
  PAY_NL_KAARTDIRECT = 'PAY_NL_KAARTDIRECT',
  ADYEN_EPS = 'ADYEN_EPS',
  ADYEN_BANCONTACT_PAYCONIQ = 'ADYEN_BANCONTACT_PAYCONIQ',
  OMISE_PROMPTPAY = 'OMISE_PROMPTPAY',
  OMISE_TRUEMONEY = 'OMISE_TRUEMONEY',
  ADYEN_MULTIBANCO = 'ADYEN_MULTIBANCO',
  PACYPAY_WECHAT = 'PACYPAY_WECHAT',
  PACYPAY_ALIPAY = 'PACYPAY_ALIPAY',
  ADYEN_MBWAY = 'ADYEN_MBWAY',
  XENDIT_DANA = 'XENDIT_DANA',
  XENDIT_SHOPEEPAY = 'XENDIT_SHOPEEPAY',
  ADYEN_PAYSHOP = 'ADYEN_PAYSHOP',
  ADYEN_PAYTRAIL = 'ADYEN_PAYTRAIL',
  CLEARPAY = 'CLEARPAY',
  RAPYD_FAST = 'RAPYD_FAST',
  RAPYD_PROMPTPAY = 'RAPYD_PROMPTPAY',
  RAPYD_GCASH = 'RAPYD_GCASH',
  RAPYD_POLI = 'RAPYD_POLI',
  RAPYD_GRABPAY = 'RAPYD_GRABPAY',
  PRIMER_PAYPAL = 'PRIMER_PAYPAL',
  TWOC2P = 'TWOC2P',
  NETS = 'NETS',
  STRIPE_GIROPAY = 'STRIPE_GIROPAY',
  MOLLIE_GIROPAY = 'MOLLIE_GIROPAY',
  MOLLIE_EPS = 'MOLLIE_EPS',
  PAY_NL_EPS = 'PAY_NL_EPS',
  PAY_NL_P24 = 'PAY_NL_P24',
  MOLLIE_P24 = 'MOLLIE_P24',
  MOLLIE_SOFORT = 'MOLLIE_SOFORT',
  COINBASE = 'COINBASE',
  OPENNODE = 'OPENNODE',
  MOLLIE_GIFT_CARD = 'MOLLIE_GIFTCARD',
  XFERS_PAYNOW = 'XFERS_PAYNOW',
  CARD = 'PAYMENT_CARD',
  APPLE_PAY = 'APPLE_PAY',
  GOOGLE_PAY = 'GOOGLE_PAY',
  PAYPAL = 'PAYPAL_ORDER',
  PAYPAL_VAULTED = 'PAYPAL_BILLING_AGREEMENT',
  GO_CARDLESS = 'GOCARDLESS',
  PAY_NL_IDEAL = 'PAY_NL_IDEAL',
  PAY_NL_SOFORT_BANKING = 'PAY_NL_SOFORT_BANKING',
  PAY_NL_BANCONTACT = 'PAY_NL_BANCONTACT',
  PAY_NL_PAYPAL = 'PAY_NL_PAYPAL',
  PAY_NL_CREDIT_TRANSFER = 'PAY_NL_CREDIT_TRANSFER',
  PAY_NL_DIRECT_DEBIT = 'PAY_NL_DIRECT_DEBIT',
  PAY_NL_GIROPAY = 'PAY_NL_GIROPAY',
  PAY_NL_PAYCONIQ = 'PAY_NL_PAYCONIQ',
  HOOLAH = 'HOOLAH',
  ADYEN_BLIK = 'ADYEN_BLIK',
  ADYEN_VIPPS = 'ADYEN_VIPPS',
  ADYEN_GIROPAY = 'ADYEN_GIROPAY',
  ADYEN_SOFORT = 'ADYEN_SOFORT',
  ADYEN_TRUSTLY = 'ADYEN_TRUSTLY',
  ADYEN_ALIPAY = 'ADYEN_ALIPAY',
  ADYEN_TWINT = 'ADYEN_TWINT',
  ADYEN_MOBILEPAY = 'ADYEN_MOBILEPAY',
  MOLLIE_BANCONTACT = 'MOLLIE_BANCONTACT',
  MOLLIE_IDEAL = 'MOLLIE_IDEAL',
  BUCKAROO_GIROPAY = 'BUCKAROO_GIROPAY',
  BUCKAROO_EPS = 'BUCKAROO_EPS',
  BUCKAROO_SOFORT = 'BUCKAROO_SOFORT',
  BUCKAROO_BANCONTACT = 'BUCKAROO_BANCONTACT',
  BUCKAROO_IDEAL = 'BUCKAROO_IDEAL',
  ATOME = 'ATOME',
}

export enum PaymentMethodType {
  ADYEN_KLARNA = 'ADYEN_KLARNA',
  ADYEN_BANCONTACT_CARD = 'ADYEN_BANCONTACT_CARD',
  PAY_NL_KAARTDIRECT = 'PAY_NL_KAARTDIRECT',
  ADYEN_EPS = 'ADYEN_EPS',
  ADYEN_BANCONTACT_PAYCONIQ = 'ADYEN_BANCONTACT_PAYCONIQ',
  OMISE_PROMPTPAY = 'OMISE_PROMPTPAY',
  OMISE_TRUEMONEY = 'OMISE_TRUEMONEY',
  ADYEN_MULTIBANCO = 'ADYEN_MULTIBANCO',
  PACYPAY_WECHAT = 'PACYPAY_WECHAT',
  PACYPAY_ALIPAY = 'PACYPAY_ALIPAY',
  ADYEN_MBWAY = 'ADYEN_MBWAY',
  XENDIT_DANA = 'XENDIT_DANA',
  XENDIT_SHOPEEPAY = 'XENDIT_SHOPEEPAY',
  ADYEN_PAYSHOP = 'ADYEN_PAYSHOP',
  ADYEN_PAYTRAIL = 'ADYEN_PAYTRAIL',
  CLEARPAY = 'CLEARPAY',
  RAPYD_FAST = 'RAPYD_FAST',
  RAPYD_PROMPTPAY = 'RAPYD_PROMPTPAY',
  RAPYD_GCASH = 'RAPYD_GCASH',
  RAPYD_POLI = 'RAPYD_POLI',
  RAPYD_GRABPAY = 'RAPYD_GRABPAY',
  PRIMER_PAYPAL = 'PRIMER_PAYPAL',
  TWOC2P = 'TWOC2P',
  NETS = 'NETS',
  STRIPE_GIROPAY = 'STRIPE_GIROPAY',
  MOLLIE_GIROPAY = 'MOLLIE_GIROPAY',
  MOLLIE_EPS = 'MOLLIE_EPS',
  PAY_NL_EPS = 'PAY_NL_EPS',
  PAY_NL_P24 = 'PAY_NL_P24',
  MOLLIE_P24 = 'MOLLIE_P24',
  MOLLIE_SOFORT = 'MOLLIE_SOFORT',
  COINBASE = 'COINBASE',
  OPENNODE = 'OPENNODE',
  MOLLIE_GIFT_CARD = 'MOLLIE_GIFTCARD',
  XFERS_PAYNOW = 'XFERS_PAYNOW',
  PAYMENT_CARD = 'PAYMENT_CARD',
  APPLE_PAY = 'APPLE_PAY',
  GOOGLE_PAY = 'GOOGLE_PAY',
  PAYPAL = 'PAYPAL',
  GO_CARDLESS = 'GOCARDLESS',
  KLARNA = 'KLARNA',
  PAY_NL_IDEAL = 'PAY_NL_IDEAL',
  PAY_NL_SOFORT_BANKING = 'PAY_NL_SOFORT_BANKING',
  PAY_NL_BANCONTACT = 'PAY_NL_BANCONTACT',
  PAY_NL_PAYPAL = 'PAY_NL_PAYPAL',
  PAY_NL_CREDIT_TRANSFER = 'PAY_NL_CREDIT_TRANSFER',
  PAY_NL_DIRECT_DEBIT = 'PAY_NL_DIRECT_DEBIT',
  PAY_NL_GIROPAY = 'PAY_NL_GIROPAY',
  PAY_NL_PAYCONIQ = 'PAY_NL_PAYCONIQ',
  HOOLAH = 'HOOLAH',
  ADYEN_BLIK = 'ADYEN_BLIK',
  ADYEN_MOBILEPAY = 'ADYEN_MOBILEPAY',
  ADYEN_VIPPS = 'ADYEN_VIPPS',
  ADYEN_GIROPAY = 'ADYEN_GIROPAY',
  ADYEN_SOFORT = 'ADYEN_SOFORT',
  ADYEN_TRUSTLY = 'ADYEN_TRUSTLY',
  ADYEN_ALIPAY = 'ADYEN_ALIPAY',
  ADYEN_TWINT = 'ADYEN_TWINT',
  ADYEN_BANK_TRANSFER = 'ADYEN_BANK_TRANSFER',
  MOLLIE_BANCONTACT = 'MOLLIE_BANCONTACT',
  MOLLIE_IDEAL = 'MOLLIE_IDEAL',
  BUCKAROO_GIROPAY = 'BUCKAROO_GIROPAY',
  BUCKAROO_EPS = 'BUCKAROO_EPS',
  BUCKAROO_SOFORT = 'BUCKAROO_SOFORT',
  BUCKAROO_BANCONTACT = 'BUCKAROO_BANCONTACT',
  BUCKAROO_IDEAL = 'BUCKAROO_IDEAL',
  ATOME = 'ATOME',
}

export enum CardPaymentMethodType {
  PAYMENT_CARD = 'PAYMENT_CARD',
  ADYEN_BANCONTACT_CARD = 'ADYEN_BANCONTACT_CARD',
}

export enum TokenType {
  SINGLE_USE = 'SINGLE_USE',
  MULTI_USE = 'MULTI_USE',
}

const PAYMENT_INSTRUMENT_TYPE_TO_PAYMENT_METHOD_TYPE = {
  [PaymentInstrumentType.PAYPAL_VAULTED]: PaymentMethodType.PAYPAL,
};

export const paymentInstrumentTypeToPaymentMethodType = (
  paymentInstrumentType: PaymentInstrumentType,
): PaymentMethodType | undefined => {
  if (
    (Object.values(PaymentMethodType) as string[]).includes(
      paymentInstrumentType as string,
    )
  ) {
    return (paymentInstrumentType as unknown) as PaymentMethodType;
  }

  if (PAYMENT_INSTRUMENT_TYPE_TO_PAYMENT_METHOD_TYPE[paymentInstrumentType]) {
    return PAYMENT_INSTRUMENT_TYPE_TO_PAYMENT_METHOD_TYPE[
      paymentInstrumentType
    ];
  }

  return undefined;
};
